import { useMemo, useState } from 'react';
import { STICKY_SUB_NAV_POSITION_CLASSES } from '@/constants/stickySubNavPositionClasses';
import { cn } from '@/lib/utils';
import { ZonesNavigation } from '../MusicZones/components/zonesNavigation';
import { ZonesSubfilter } from '../MusicZones/components/zonesSubfilter';
import type { Zone } from '../MusicZones/types';
import { MG_ZONE_LINKS } from './zone-links';
export const MotionGraphicsZonesNavigation = ({
  zone,
  className
}: {
  zone?: Zone;
  className?: string;
}) => {
  const [selectedSection, setSelectedSection] = useState<string>('');

  // Extract sections from carousels (excluding "Other")
  const sections = useMemo(() => zone?.carousels?.filter(carousel => carousel.name !== 'Other')?.map(carousel => ({
    id: carousel.name,
    name: carousel.name,
    slug: carousel.name.toLowerCase().replace(/\s+/g, '-')
  })) || [], [zone?.carousels]);
  const handleSectionChange = (sectionId: string) => {
    setSelectedSection(sectionId);
  };
  return <div className={cn('sticky z-20', STICKY_SUB_NAV_POSITION_CLASSES, className)} data-sentry-component="MotionGraphicsZonesNavigation" data-sentry-source-file="zones-navigation.tsx">
      <div className="bg-white dark:bg-gray-950" style={{
      transition: 'padding-top 0.2s ease-out'
    }}>
        <ZonesNavigation currentZoneSlug={'featured'} zones={MG_ZONE_LINKS} data-sentry-element="ZonesNavigation" data-sentry-source-file="zones-navigation.tsx" />
      </div>
      <div className="bg-white dark:bg-gray-950" style={{
      transition: 'padding-bottom 0.2s ease-out'
    }}>
        <ZonesSubfilter activeSection={selectedSection} isVisible={true} onSectionChange={handleSectionChange} sections={sections} data-sentry-element="ZonesSubfilter" data-sentry-source-file="zones-navigation.tsx" />
      </div>
    </div>;
};